import Kolla from 'kolla';
import { store, TOKEN } from '../store';
const KOLLA_TOKEN = process.env.REACT_APP_KOLLA_TOKEN;
const KOLLA_API_HOST = process.env.REACT_APP_KOLLA_API_HOST;
const NODE_ENV = process.env.NODE_ENV;
const { parseJwt } = require('../utils/jwt');

let workspaceId;
if (KOLLA_TOKEN) {
  Kolla.init(KOLLA_TOKEN, { api_host: KOLLA_API_HOST });

  store[TOKEN].subscribe((value) => {
    try {
      if (value) {
        const { user_id, role, plan, workspace_id } = parseJwt(value);
        workspaceId = workspace_id;
        Kolla.identify(user_id, { role, plan });
      }
    } catch (err) {
      console.error('KollaSDK: identify', err);
    }
  });
}

export function track(event, data, experiment) {
  if (!KOLLA_TOKEN) {
    if (NODE_ENV === 'development') {
      console.info('KollaSDK: track', event, data);
    }
    return;
  }
  try {
    Kolla.track(event, data, experiment);
  } catch (err) {
    console.error('KollaSDK: track', err);
  }
}

export function createExperiment(name, variants, hashId) {
  if (!variants) {
    variants = [false, true];
  }
  return Kolla.createExperiment(name, variants, hashId || workspaceId);
}
